import React from "react"
import Layout from '../components/Layout'
import ContenidoNosotros from "../components/ContenidoNosotros"

const IndexPage = () => (
  <Layout>
    <ContenidoNosotros/>
  </Layout>
)

export default IndexPage
